import { useContext } from 'react';
import { DocumentDrawerContext } from '../../components/DocumentDrawer/Provider';
export const useDocumentDrawer = () => {
    const context = useContext(DocumentDrawerContext);
    if (!context) {
        throw new Error('useDocumentDrawer hook used outside <DocumentDrawerProvider />');
    }
    return context;
};
